import { Col, Form, Row } from "antd";
import { CDatePicker, propsDate } from "components";
import { FC } from "react";

export interface IHeaderOverview {
  title: string;
  onChange?: (v: any) => void;
  formatDate?: string | "year";
  name: string;
  subTitle?: string;
}

export const HeaderOverview: FC<IHeaderOverview> = ({
  title,
  onChange,
  formatDate,
  name,
  subTitle,
}) => {
  const props = propsDate({ year: formatDate === "year" });
  return (
    <Row className="xl:h-[60px] lg:h-[80px] ">
        <Col span={14} style={{ fontSize: "18px" }}>
       {subTitle && <div className="flex justify-start gap-1">
          <div>{title}</div>
          <div>{subTitle}</div>
        </div>}
        {!subTitle && <div>{title}</div>}
      </Col>
      <Col span={10} className="grid justify-items-end ">
        <Form.Item noStyle name={name}>
          <CDatePicker {...props} onChange={onChange} />
        </Form.Item>
      </Col>
    </Row>
  );
};
